import { useAuth as useOidcAuth } from "react-oidc-context";
import { getUserRole } from "../utils/jwtUtils";
import { currentReturnState } from "../utils/signInReturn";

export const useAuth = () => {
  const auth = useOidcAuth();

  // More comprehensive authentication state check
  const isAuthenticated = !!(auth.user && !auth.user.expired && !auth.isLoading);
  
  // Extract user role if authenticated
  const userRole = (isAuthenticated && auth.user?.access_token) 
    ? getUserRole(auth.user.access_token) 
    : null;

  // Debug authentication state
  // console.log("Auth Debug:", {
  //   user: !!auth.user,
  //   userExpired: auth.user?.expired,
  //   isLoading: auth.isLoading,
  //   error: auth.error?.message,
  //   activeNavigator: auth.activeNavigator,
  //   isAuthenticated: isAuthenticated,
  //   accessToken: !!auth.user?.access_token,
  //   tokenExpiry: auth.user?.expires_at ? new Date(auth.user.expires_at * 1000).toISOString() : null,
  // });

  // Log errors for debugging
  if (auth.error) {
    console.error("OIDC Auth Error:", auth.error);
  }

  return {
    isAuthenticated: isAuthenticated,
    isLoading: auth.isLoading,
    user: auth.user,
    userRole,
    token: auth.user?.access_token,
    login: () => {
      console.log("🔑 Initiating login redirect...");
      // The page being signed in to rides along, so the callback comes back to it rather than
      // to the landing page (see `signInReturn.ts`).
      return auth.signinRedirect({ state: currentReturnState() });
    },
    logout: () => {
      console.log("🚪 Initiating logout redirect...");
      return auth.signoutRedirect();
    },
    error: auth.error,
  };
};

export default useAuth;
